module.exports = __webpack_public_path__ + "static/img/biankuang_m03.e73b001.png";


//////////////////
// WEBPACK FOOTER
// ./static/biankuang_m03.png
// module id = m4pu
// module chunks = 1